﻿import SimpleBar from "simplebar";
import { processMarkedForRemove, replaceContentSmooth, smoothReplaceItemsToHandle, windowMedia } from "../../helpers";
import { getTranslations } from "../../translations";
import { getUserApiAuthorize } from "../../utilities/api.userauth";
import { ProductComparer } from "./productcomparer";
import device from "current-device";

const productComparerStickyCollapsedKey = "compareprod_sticky_collapsed";

const prodCompSticky =
    `<div class=\"c-productcomparer-widget js-productcomparer-widget {iscollapsed}\">
        <div class=\"c-productcomparer-widget__wrapper\">
            <div class=\"c-productcomparer-widget__header\" onclick=\"toggleProductComparerSticky();\">
                <div class=\"c-productcomparer-widget-header__toggle\"></div>
                <div class="c-productcomparer-widget-header__text">                                        
                ${getTranslations().comparePluralTitleText} <span class=\"u-badge--white\">{articlecount}</span>
                </div>
            </div>
            <div class=\"c-productcomparer-widget__content\">
                <div class=\"c-productcomparer-widget-content__text js-productcomparer-scrollbar\">{articlecontent}</div>            
                <div class=\"c-productcomparer-widget-content-footer\">
                    <a
                        class=\"c-productcomparer-widget-footer__button btn-pink js-productcomparer-show {isdisabled}\"
                        href=\"${getTranslations().prodCompPageUrl}\" 
                        rel="nofollow" 
                        title=\"${getTranslations().compareSingularTitleText}\">
                        ${getTranslations().compareSingularTitleText}
                    </a>
                    <a class=\"c-productcomparer-widget-footer__removeall f-primary-s js-productcomparer-remove-all"\ onclick=\"clearProductComparer(); return false;\" title=\"${getTranslations().txtRemoveAll}\">${getTranslations().txtRemoveAll}</a>
                </div>
            </div>
        </div>
    </div>`;

const prodCompStickyArticleItem =
    `<div class=\"c-productcomparer-product__article\" class=\"c-productcomparer-product\" data-articleid=\"{articleid}\"  data-productid=\"{productid}\" data-articlenumber=\"{articlenumber}\">
        <a tabindex=\"-1\" class=\"c-productcomparer-product__imageholder\" href=\"{articleurl}\" title=\"{name}\">
            <img class=\"c-productcomparer-product__image\" src=\"${shopConfig().staticDomain}{image}\" alt=\"{name}\" width=\"432\" height=\"432\" loading=\"lazy\" />
        </a>
        <a class=\"c-productcomparer-product__articledata\" href=\"{articleurl}\" title=\"{name}\">
            <span class=\"c-productcomparer-product__brand f-primary-s tl-bold\">{brand}</span>
            <span class=\"c-productcomparer-product__name f-primary-s\">{name_no_brand}</span>
            <span class=\"c-productcomparer-product__price f-primary-l\">{price}</span>
        </a>
        <div class=\"c-productcomparer-product__remove js-productcomparer-remove\">
        </div>
    </div>`;

const prodCompStickyMobileBlock =
    `<a class=\"c-productcomparer-widget-footer__button {isdisabled}\" href=\"${getTranslations().prodCompPageUrl}\" rel="nofollow" title=\"${getTranslations().compareSingularTitleText}\">
        ${getTranslations().comparePluralTitleText} {articlecount}/${shopConfig().productCompareMaxCount}
    </a>`;

document.addEventListener("DOMContentLoaded", function ()
{
    const comparer = new ProductComparer(true);
    const popup = comparer.currentPopup;
    comparer.checkProdCompareAddButtons();
    popup.initPopup();
});

export const reInitProductComparer = () =>
{
    const comparer = new ProductComparer(true);
    const popup = comparer.currentPopup;
    comparer.checkProdCompareAddButtons();
    popup.initPopup();
}

export class ProductComparerPopup
{
    comparer: ProductComparer;
    checkingProdCompStickyMobile: Boolean = false;
    prevRecalcProdCompStickyOffset: number = -1;
    loopArticles: any[];
    loopArticlesLength: number;

    constructor(comparer: ProductComparer)
    {
        $(".js-productcomparer-widget").remove();
        this.comparer = comparer;
    }

    public initPopup()
    {
        if (this.comparer.getCompareProdArts().length > 0)
            this.initProductCompareStickySummary(true);
    }

    private showPopup(): boolean
    {
        if ($("#productcomparerpage").length > 0)
            return false;

        return true;
    }

    public initProductCompareStickySummary(skipRetrievingProdArt: boolean)
    {
        const popup = this;
        // Do not show sticky block if on compare page.
        if (this.showPopup())
        {
            const functionToHandle = {
                functionName: "getProductComparerArticlesForSticky",
                parameters: [false, false, null],
                handleFunction: function ()
                {
                    return popup.getProductComparerArticlesForSticky(this.parameters[0], this.parameters[1], this.parameters[2], false);
                }
            };

            if (!skipRetrievingProdArt)
                // Get up-to-date data (from DB if logged in, otherwise from localstorage).
                this.comparer.loadProductComparerArticles(functionToHandle, skipRetrievingProdArt);
            else
                functionToHandle.handleFunction();
        }
    }

    private getProductComparerArticlesForSticky(showDifferenceOnly, showDifferenceToggled, productArticlesOverride, reloadArticles)
    {
        const popup = this;
        var functionToHandle = {
            functionName: null,
            parameters: null,
            handleFunction: function ()
            {
                return popup.comparer.getProductComparerArticles(
                    popup,
                    showDifferenceOnly,
                    showDifferenceToggled,
                    productArticlesOverride,
                    popup.loadProductCompareStickySummaryData,
                    false
                );
            }
        };

        if (reloadArticles && getUserApiAuthorize())
            this.comparer.loadProductComparerArticles(functionToHandle, true);
        else
            functionToHandle.handleFunction();
    }

    private loadProductCompareStickySummaryData(popup, articleData)
    {
        try
        {
            if (typeof articleData === typeof undefined ||
                articleData == null ||
                $(articleData.articles).length <= 0
            )
                $(".js-productcomparer-widget").remove();
            else
            {
                var articleContent = "";
                var articleRemoveAllContent = "";

                popup.loopArticles = $(articleData.articles).get().reverse();
                popup.loopArticlesLength = $(articleData.articles).length;

                popup.loopArticles.forEach((item, index) =>
                {
                    // Set article content.
                    const articleElement = prodCompStickyArticleItem
                        .replaceAll("{productid}", item.productID)
                        .replaceAll("{articleid}", item.articleID)
                        .replaceAll("{articlenumber}", item.articleNumber)
                        .replaceAll("{brand}", item.brand)
                        .replaceAll("{name}", item.name)
                        .replaceAll("{name_no_brand}", item.name.replace(item.brand, "").trim())
                        .replaceAll("{articleurl}", item.articleUrl)
                        .replaceAll("{image}", item.articlePhoto)
                        .replaceAll("{price}", item.price.toString().replace(".", ","))
                        .replaceAll("{oldprice}", (item.oldPrice || "").toString().replace(".", ","))
                        .replaceAll("{islowestprice}", item.lowestPrice ? "visible" : "hidden")
                        .replaceAll("{issoldout}", item.soldout ? "item-soldout" : "");

                    articleContent += articleElement;

                    if (articleRemoveAllContent.length > 0)
                        articleRemoveAllContent += ",";

                    articleRemoveAllContent += `{productID: ${item.productID}, articleID: ${item.articleID}}`;
                });

                const isStickyCollapsed = sessionStorage.getItem(productComparerStickyCollapsedKey);
                var stickyContent = prodCompSticky
                    .replaceAll("{articlecount}", popup.loopArticlesLength)
                    .replaceAll("{articlecontent}", articleContent)
                    .replaceAll("{removeallarticlesdata}", `[${articleRemoveAllContent}]`)
                    .replaceAll("{isdisabled}", popup.loopArticlesLength == 1 ? "disabled" : "")
                    .replaceAll("{iscollapsed}", isStickyCollapsed === "true" || isStickyCollapsed == null ? "c-productcomparer-widget--collapsed" : "");

                var stickyContentMobile = prodCompStickyMobileBlock
                    .replaceAll("{mobilebottom}", popup.getProdCompStickyOffset().toString())
                    .replaceAll("{articlecount}", popup.loopArticlesLength)
                    .replaceAll("{isdisabled}", popup.loopArticlesLength == 1 ? "disabled" : "");

                if ($(".js-productcomparer-widget").length > 0)
                {
                    replaceContentSmooth(".js-productcomparer-widget .c-productcomparer-widget__wrapper", $(stickyContent).find(".c-productcomparer-widget__wrapper")[0].innerHTML, true, null).then(() =>
                    {
                        popup.addStickyPopupEvents();
                    });

                    var intervalCurrentTryCount = 0;
                    var intervalMaxTryCount = 100;
                    var intervalDelay = 10;

                    var interval = setInterval(function ()
                    {
                        // Remove old content after the CSS-animation finished, for a smooth transition.
                        // Ensure replace when max try count was reached.
                        if (smoothReplaceItemsToHandle <= 0 ||
                            intervalCurrentTryCount >= intervalMaxTryCount)
                        {
                            clearInterval(interval);

                            // Remove all old content that was marked for deletion.
                            processMarkedForRemove();
                        }
                        else
                            intervalCurrentTryCount++;
                    }, intervalDelay);

                    $(".js-productcomparer-widget").addClass("updating");

                    setTimeout(function ()
                    {
                        $(".js-productcomparer-widget").removeClass("updating");

                        if (this.setStickyScroll)
                            this.setStickyScroll();
                    }, 420);
                }
                else
                {
                    $(".js-productcomparer-widget").remove();
                    $("main").append(stickyContent);

                    popup.setStickyScroll();
                }
                popup.addStickyPopupEvents();
            }
        }
        catch (err)
        {
            console.log(err);
        }
    }

    private addStickyPopupEvents = () =>
    {
        const popup = this;
        $(".js-productcomparer-remove").off("click");
        $(".js-productcomparer-remove").on("click", function (e)
        {
            e.stopPropagation();
            e.preventDefault();
            const parent = $(this).closest(".c-productcomparer-product__article");
            const productID = $(parent).data("productid");
            const articleID = $(parent).data("articleid");
            const articlenumber = $(parent).data("articlenumber");

            popup.comparer.removeProductComparerArticle(productID, articleID, articlenumber);

            setTimeout(function ()
            {
                $(parent).remove();
            }, 100);
            return false;
        });
    };

    private setStickyScroll()
    {
        setTimeout(function ()
        {
            if ($(".js-productcomparer-scrollbar").length > 0)
            {
                new SimpleBar($(".js-productcomparer-scrollbar")[0],
                    {
                        autoHide: false,
                        tabIndex: -1
                    }
                );
            }
        }, 1);
    }

    private getProdCompStickyOffset(): number
    {
        var prodCompMobileBottom = 0;

        if (windowMedia())
        {
            var pdpStickyHeight = $(".product-detail .btp:visible").outerHeight();
            var cookieHeight = $(".estrategy-cc-popup-mobile:visible").outerHeight();
            var siteNotificationHeight = $(".maintenance-notification:visible").outerHeight();

            if (pdpStickyHeight &&
                pdpStickyHeight > 0
            )
                prodCompMobileBottom += pdpStickyHeight;

            if (cookieHeight &&
                cookieHeight > 0
            )
                prodCompMobileBottom += cookieHeight;

            if (siteNotificationHeight &&
                siteNotificationHeight > 0
            )
                prodCompMobileBottom += siteNotificationHeight;
        }

        return prodCompMobileBottom;
    }
}

const toggleProductComparerSticky = () =>
{
    const stickyWrapper = $(".js-productcomparer-widget");
    if (stickyWrapper.length > 0)
    {
        collapseProductComparer(!stickyWrapper.hasClass("c-productcomparer-widget--collapsed"));
    }
}

const collapseProductComparer = (collapse) =>
{
    const stickyWrapper = $(".js-productcomparer-widget");
    if (stickyWrapper.length > 0)
    {
        if (collapse)
            stickyWrapper.addClass("c-productcomparer-widget--collapsed");
        else
            stickyWrapper.removeClass("c-productcomparer-widget--collapsed");

        sessionStorage.setItem(productComparerStickyCollapsedKey, collapse);
    }
}

export { toggleProductComparerSticky, collapseProductComparer };

(window as any).toggleProductComparerSticky = toggleProductComparerSticky;
(window as any).collapseProductComparer = collapseProductComparer;